import { useTranslation } from 'react-i18next';
import styles from '../styles/layout/Footer.module.css';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <nav className={styles.footerNav}>
        <ul className={styles.menu}>
          <li><a href="#about" className={styles.link}>{t('footer.about')}</a></li>
          <li><a href="#privacy" className={styles.link}>{t('footer.privacy')}</a></li>
          <li><a href="#terms" className={styles.link}>{t('footer.terms')}</a></li>
          <li><a href="#contacts" className={styles.link}>{t('footer.contacts')}</a></li>
        </ul>
      </nav>
    </footer>
  );
}

export default Footer;
